import React from 'react';
import { Zap } from 'lucide-react';

const ReconcileFloatingButton = ({ lot, onClick }) => {
  if (lot.status !== 'lightning' || !lot.needs_reconciliation) return null;
  
  return (
    <div className="fixed bottom-6 inset-x-0 px-4 flex justify-center z-10">
      <button 
        onClick={onClick}
        className="flex items-center gap-2 px-6 py-3.5 bg-amber-500 text-white rounded-full shadow-lg hover:bg-amber-600 transition-colors border border-amber-400"
      >
        <Zap className="w-5 h-5" />
        <span className="font-medium">Reconciliar Lote Relámpago</span>
      </button>
    </div>
  );
};

export default ReconcileFloatingButton; 